import { CheckIcon } from '@heroicons/react/24/outline';
import { Typography } from 'components/typography/typography-component';

const ReactSquadSteps = () => {
  return (
    <div className="my-12 flex flex-col flex-wrap items-center justify-center gap-6 px-4 pt-4">
      <Typography
        variant="h2"
        className="text-center font-inter text-3xl sm:text-4xl"
      >
        Providing React developers to <br />
        fast-growing startups in {'<'}7 days.
      </Typography>

      <div className="mt-6 flex flex-col gap-y-4">
        <div className="flex items-center">
          <CheckIcon className="mb-[2px] mr-2 h-5 min-w-[1.25rem] text-[#21A366]" />
          <Typography className="font-inter">
            Get a developer embedded in your team, shipping code in {'<'}7 days
          </Typography>
        </div>
        <div className="flex items-center">
          <CheckIcon className="mb-[2px] mr-2 h-5 min-w-[1.25rem] text-[#21A366]" />
          <Typography className="font-inter">
            In-House team of engineers hyper-focused on React.js
          </Typography>
        </div>
        <div className="flex items-center">
          <CheckIcon className="mb-[2px] mr-2 h-5 min-w-[1.25rem] text-[#21A366]" />
          <Typography className="font-inter">
            100% risk-free 30-day trial period
          </Typography>
        </div>
        <div className="flex items-center">
          <CheckIcon className="mb-[2px] mr-2 h-5 min-w-[1.25rem] text-[#21A366]" />
          <Typography className="font-inter">
            Transparent Pricing: 80$/hour
          </Typography>
        </div>
      </div>
    </div>
  );
};

export default ReactSquadSteps;
